import PageLeaderboard from './PageLeaderboard';
import { connect } from 'react-redux';
import { AppState } from '../../interfaces';
import { getLeaderboard } from '../../actions/leaderboard';
import { setMeta } from '../../actions';
import { submitMeterRead } from '../../actions/meterRead';

const mapStateToProps = (state: AppState) => ({
  leaderboard: state.leaderboardReducer,
  listLocation: state.listLocationReducer,
  location: state.locationReducer,
  meterRead: state.meterReadReducer,
});
const mapDispatchToProps = (dispatch) => ({
  getLeaderboard: (propertyId) => dispatch(getLeaderboard(propertyId)),
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
  submitMeterRead: (propertyId, meterRead) =>
    dispatch(submitMeterRead(propertyId, meterRead)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PageLeaderboard);
